function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/* eslint-disable react/forbid-prop-types */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from "../..";
import { getRest } from "../../utils";

/**
 * Button to scroll top.
 *
 * @class ScrollTopButton
 * @extends {React.Component}
 */
import { jsx as _jsx } from "react/jsx-runtime";
var ScrollTopButton = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ScrollTopButton, _React$Component);
  function ScrollTopButton() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    /**
       * Handle click button.
       *
       * @memberof ScrollTopButton
       */
    _this.handleClick = function (e, data) {
      var containerRef = _this.props.containerRef;
      if (!_.isNil(containerRef) && (containerRef.scrollTo || containerRef.current)) {
        (containerRef.current || containerRef).scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
      _.invoke(_this.props, 'onClick', e, data);
    };
    return _this;
  }
  var _proto = ScrollTopButton.prototype;
  /**
     * Render the component.
     *
     * @returns
     * @memberof ScrollTopButton
     */
  _proto.render = function render() {
    var rest = getRest(ScrollTopButton, this.props);
    return /*#__PURE__*/_jsx(Button, Object.assign({
      className: "scrollButtonToTop",
      circular: true,
      size: "big",
      onClick: this.handleClick,
      icon: "angle double up"
    }, rest));
  };
  return ScrollTopButton;
}(React.Component);
/**
 * Prop types.
 */
ScrollTopButton.handledProps = ["containerRef", "onClick"];
ScrollTopButton.propTypes = {
  /** Container reference. */
  containerRef: PropTypes.object,
  /** Callback on click. */
  onClick: PropTypes.func
};
export default ScrollTopButton;